<div
  class="bn-notification-item {{ extraClass }}"
  [ngClass]="{ 'bn-notifications__item--new': !_notification?.isRead }">
  <div class="bn-notification-item__wrap">
    <div
      class="bn-notification-item__icon"
      [ngClass]="_notification?.iconUrl ? 'bn-notification-item__icon--image' : 'bn-context--' + (_notification?.contextType || 'info')">
      @if (_notification?.iconUrl) {
        <img
          class="bn-notification-item__icon-img"
          [alt]="_notification?.product"
          [src]="_notification?.iconUrl" />
      } @else {
        <fa-icon [icon]="_notification?.icon ?? 'circle-info'" />
      }
    </div>
    <div class="bn-notification-item__header">
      <span class="bn-notification-item__title">{{ _notification?.title }}</span>
      @if (showTimestamp) {
        <span class="bn-notification-item__meta">
          <span
            class="bn-notification-item__time col-auto"
            container="body"
            containerClass="mb-1"
            tooltip="{{ _notification?.timestamp | date: 'MMM d, y, H:mm' }}"
            >{{ _notification?.secondsAgo | duration: 'notification' : 'second' }}</span
          >
        </span>
      }
    </div>
    @if (content) {
      <div
        class="bn-notification-item__description"
        [innerHTML]="content"
        [ngClass]="{ 'bn-notification-item__description--limit-length': !showAll }"></div>
    }
    @if (redirectToFeedUrl && _notification?.url) {
      <a
        class="bn-notification-item__link"
        rel="noopener noreferrer"
        target="_blank"
        [href]="_notification?.url"></a>
    }
  </div>
</div>
